import React from "react";
import DynamicFormControls from "../../forms/DynamicForm/DynamicFormControls";

export const renderSearchBox = (uiSchema) => {

    let _searchBox = null;
    var filterControl = Array.isArray(uiSchema.controls) ? uiSchema.controls.filter(x => x.key.trim().toLowerCase() == 'searchfilterbox' || x.type === 'button') : [];
    if (filterControl.length > 0) {
        _searchBox = filterControl.map((control) => {
            return (
                <DynamicFormControls key={control.id} formid={uiSchema.Id} control={control} action="write" />
            );
        });
    }

    return _searchBox;
}
export const renderFilterControls = (uiSchema) => {
    return (
        <div className="row">
            {
                Array.isArray(uiSchema.controls) && uiSchema.controls.map((control) => {
                    if (control.filterresult != true && control.key !== 'searchfilterbox' && control.type !== 'button') {
                        return (
                            <DynamicFormControls key={control.id} formid={uiSchema.Id} control={control} action="write" />
                        );
                    }
                })
            }
        </div>
    )
}